export enum SliceNames {
    APP = "app",
    AUTH = "auth",
    BLOG = "blog",
    CATEGORY = "category",
    CONTACT = "contact",
    HOME = "home",
    HOW_IT_WORKS = "howItWorks",
    TICKET = "ticket",
    DASHBOARD = "dashboard",
    LEADERBOARD = "leaderboard",
    WISH = "wish",
    WISHLIST = "wishlist",
    NOTIFICATION = "notification",
    USER = "user",
    TRANSACTION = "transaction",
    PARTNER = "partner",
    DOCUMENT = "document",
    IMAGE = "image",
    CFG_ATTRIBUTE = "cfgAttribute",
    FAQ = "faq",
    CLIENT = "client",
    WISH_CODE = "wishCode"
}